import { getLocale } from "../runtime";

const sv_pricehistory = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Prishistorik`
};

const pricehistory = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_pricehistory(inputs)
	return "priceHistory";
};

export { pricehistory as "priceHistory" };